import React from 'react';
import {Helmet} from "react-helmet";
import Sidebar from "../Common/sidebar";
import FoodCard from "../Common/foodCard";
import API from "../../api";
import '/src/assets/css/home.css';
import '/src/assets/css/loading.css';
import {withRouter} from "react-router-dom";
import {BASE_URL, CapitalizeFirstLetter, EventEmitter, strReplace} from "../../helper";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import ReactPaginate from 'react-paginate';
import {connect} from "react-redux";
import {instanceOf} from "prop-types";
import {Cookies, withCookies} from "react-cookie";
import {images} from "../../constant";
import LoadingBar from "react-top-loading-bar";
import cookie from "cookie";
import CateCard from "../Common/cateCard";
import {updateList} from "../../actions/list";
import ActiveFilterChip from "./ActiveFilterChip";
import CustomSelect from "../Common/CustomSelect";
import PageIntro from "../Common/PageIntro";
import CustomerReviews from "../Common/CustomerReviews";
const api = new API();
let timerId;

class SearchItem extends React.Component {

    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };

    static async getInitialProps(ctx) {

        const { req , location } = ctx;

        let selectedStore = null;
        if (req && req.headers && req.headers.cookie) {
            // On the server-side, you can access cookies using headers.cookie
            const cookies = cookie.parse(req.headers.cookie);
            selectedStore = cookies?.selected_store || 2; //Default mesa
        } else if (typeof window !== 'undefined') {
            // On the client-side, you can access cookies using document.cookie
            const cookies = cookie.parse(document.cookie);
            selectedStore = cookies?.selected_store || 2; //Default mesa
        }

        var data = {keyword: "", categories_slug: "", restaurant_id: selectedStore};
        const categories_slug = location?.state?.categories_slug;
        const categories_name =  location?.state?.categories_name;
        if (categories_slug){
            data = {keyword: "", categories_slug: categories_slug, restaurant_id: selectedStore};
        }
        const products = await api.getFilterProduct(data);

        return {
            categories_slug : categories_slug !== undefined ? categories_slug : null,
            categories_name : categories_name !== undefined ? categories_name : null,
            search_all_products: products.data.response.data,
            page_meta: products.data.response.meta,
            progress : 100,
            test_match : categories_slug + categories_name
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            filter_data: {
                keyword : null,
                range: [0, 1000],
                categories_slug: null,
                categories_name: null,
                restaurant_id: this.props.cookies.get('selected_store') !== undefined ? this.props.cookies.get('selected_store') : 2,
                default_preference: this.props.cookies.get('selected_preference') ? this.props.cookies.get('selected_preference') : 1, //Pickup
                filter: {
                    is_prime: false,
                    is_bulk: false,
                    made_locally : false,
                    ebt_enabled : false,
                    is_on_sell : false
                },
                lowToHigh: false,
                highToLow: false
            },
            progress : 0,
            search_keyword : null,
            seo_search: 1,
            show_loader: true,
            page_meta: null,
            loading: true,
            dropdown: false,
            products: [],
            storeItem: [],
            toggle_menu_class: "sidebar borderBoxWithRadius",
            toggle_menu_class_show: "",
            blogs : []
        };
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleRedirection = this.handleRedirection.bind(this);
        this.topRedirection = this.topRedirection.bind(this);
        this.handleToggleOpen = this.handleToggleOpen.bind(this);
        this.handleToggleClose = this.handleToggleClose.bind(this);
        this.handleReset = this.handleReset.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        const keyword = localStorage.getItem("keyword");
        const keyword_data = JSON.parse(keyword);
        if (keyword_data?.key && keyword_data?.key !== this.state.filter_data.keyword){
            this.changeKeywordFilter();
        }

        if (this.props.cookies.get('selected_store') !== undefined && this.props.cookies.get('selected_store') !== this.state.filter_data?.restaurant_id){
            this.setState({filter_data: {...this.state.filter_data, restaurant_id: this.props.cookies.get('selected_store')}})
        }

        if (this.props.cookies.get('selected_preference') !== undefined && this.props.cookies.get('selected_preference') !== this.state.default_preference) {
            this.setState({default_preference: this.props.cookies.get('selected_preference')});
        }

        EventEmitter.subscribe('changeFilter', () => {
            this.changeProductFilter();
        });

        EventEmitter.subscribe('changeHeaderToggle', () => {
            this.handleToggleOpen();
        });

        EventEmitter.subscribe('changeKeywordFilter', () => {
            this.changeKeywordFilter();
        });

        EventEmitter.subscribe('changeResetFilter', () => {
            this.changeProductResetFilter();
        });

        EventEmitter.subscribe('changeFilterFromCate', () => {
            EventEmitter.dispatch('changeResetFilter');
        });

        EventEmitter.subscribe('changeFilterFromFooter', () => {
            EventEmitter.dispatch('changeResetFilter');
        });

        EventEmitter.subscribe('sidebarToggleClose', () => {
            this.setState({toggle_menu_class: "", toggle_menu_class_show: ""},()=>{
                document.getElementById("body-mob").classList.remove('fixed-position');
            });
        });

        if (!this.props.list || Object.keys(this.props.list).length === 0) {
            this.props.updateUserList({
                token: this.props.cookies.get('token') || "default",
                list_unique_id: this.props.cookies.get('list_unique_id') || "default",
            });
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.cartAddedItems?.cart_items && this.props.cartAddedItems?.cart_items.length > 0 && this.props.cookies.get('toggle') === "") {
            const {cookies} = this.props;
            cookies.set('toggle', 'toggled');
        }
        if (this.props.cookies.get('selected_store') !== undefined && this.props.cookies.get('selected_store') !== this.state.filter_data?.restaurant_id){
            this.setState({filter_data: {...this.state.filter_data, restaurant_id: this.props.cookies.get('selected_store')}},()=>{
                this.getFilterProducts();
            });
        }
        if (this.props.cookies.get('selected_preference') !== undefined && this.props.cookies.get('selected_preference') !== this.state.default_preference) {
            this.setState({default_preference: this.props.cookies.get('selected_preference')});
        }
    }

    changeProductResetFilter() {
        const filters = localStorage.getItem("filter");
        const data = JSON.parse(filters);
        data.lowToHigh = false;
        data.highToLow = false;
        data.keyword  = null ; //this.state.filter_data?.keyword;
        data.restaurant_id = this.state.filter_data?.restaurant_id;
        this.setState({progress : 30 ,filter_data: data , search_keyword : ""}, () => {
            this.getFilterProducts();
        })
    }

    changeProductFilter() {
        const filters = localStorage.getItem("filter");
        const data = JSON.parse(filters);
        data.keyword  = this.state.filter_data?.keyword;
        if (data.categories_slug){
            data.keyword = null ;
            this.setState({search_keyword : ""})
        }
        data.restaurant_id = this.state.filter_data?.restaurant_id;
        this.setState({progress : 30 ,filter_data: data}, () => {
            this.getFilterProducts();
        })
    }

    changeKeywordFilter(){
        const keyword = localStorage.getItem("keyword");
        const keyword_data = JSON.parse(keyword);
        const data =  {
            page : 1 ,
            keyword : keyword_data.slug,
            range: [0, 1000],
            categories_slug: "",
            categories_name: "",
            restaurant_id: this.props.cookies.get('selected_store') !== undefined ? this.props.cookies.get('selected_store') : 2,
            filter: {
                is_prime: false,
                is_bulk: false,
                ebt_enabled : false,
                made_locally : false,
                is_on_sell : false
            },
            lowToHigh: false,
            highToLow: false
        };
        this.setState({progress : 30 ,filter_data: data,search_keyword : keyword_data?.key }, () => {
            this.getFilterProducts();
        })
    }


    handleToggleOpen() {
        document.getElementById("body-mob").classList.add('fixed-position');
        this.setState({toggle_menu_class: "sidebar show-filter", toggle_menu_class_show: "show-drop"})
    }

    handleToggleClose() {
        document.getElementById("body-mob").classList.remove("fixed-position");
        this.setState({toggle_menu_class: "", toggle_menu_class_show: ""},()=>{
            EventEmitter.dispatch('sidebarToggleClose');
        })
    }

    handleReset() {
        this.setState({
            search_keyword : null,
            filter_data: {...this.state.filter_data,
                keyword : null,
                range: [0, 1000],
                categories_slug: null,
                categories_name: null,
                restaurant_id: this.props.cookies.get('selected_store') !== undefined ? this.props.cookies.get('selected_store') : 2,
                filter: {
                    is_prime: false,
                    is_bulk: false,
                    ebt_enabled:false,
                    made_locally : false,
                    is_on_sell : false
                },
                lowToHigh: false,
                highToLow: false
            }},()=>{
            this.getFilterProducts();
            EventEmitter.dispatch('changeCategoryResetFilter');
        });
    }

    handleRedirection(path) {
        this.setState({
            search_keyword : null,
            filter_data: {...this.state.filter_data,
                keyword : null,
                range: [0, 1000],
                categories_slug: null,
                categories_name: null,
                restaurant_id: this.props.cookies.get('selected_store') !== undefined ? this.props.cookies.get('selected_store') : 2,
                filter: {
                    is_prime: false,
                    is_bulk: false,
                    ebt_enabled :false,
                    made_locally : false,
                    is_on_sell : false
                },
                lowToHigh: false,
                highToLow: false
        }},()=>{
            EventEmitter.dispatch('changeCategoryResetFilter');
        });
    }

    topRedirection() {
        window.scrollTo(0, 0);
    }

    handlePageChange(pageNumber) {
        this.setState({progress : 30});
        let data = this.state.filter_data;
        data.page = pageNumber.selected + 1;
        api.getFilterProduct(data).then(products => {
            this.setState({
                loading: false,
                storeItem: products.data.response.data,
                filter_data: data,
                page_meta: products.data.response.meta,
                progress : 100
            });
            window.scrollTo(0, 0);
        });
    }

    getFilterProducts() {

        clearTimeout(timerId);

        timerId = setTimeout(
            function () {
                const data = this.state.filter_data;
                api.getFilterProduct(data).then(products => {
                    this.setState({
                        loading: false,
                        storeItem: products.data.response.data,
                        filter_data: data,
                        page_meta: products.data.response.meta,
                        seo_search: 0,
                        progress : 100
                    });
                });
                window.scrollTo(0, 0);

            }.bind(this),
            100
        );
    }

    sortingWithPrice(e) {

        this.setState({progress : 30 });

        const data = this.state.filter_data;

        if (e.target.value === "0") {
            data.lowToHigh = false;
            data.highToLow = false;
        }

        if (e.target.value === "2") {
            data.lowToHigh = true;
            data.highToLow = false;
        }

        if (e.target.value === "1") {
            data.lowToHigh = false;
            data.highToLow = true;
        }

        this.setState({
            ...this.state.filter_data,
            filter_data: data
        }, () => {
            this.getFilterProducts();
        });
    }

    handleClear() {
        const data = this.state.filter_data;
        data.lowToHigh = false;
        data.highToLow = false;
        this.setState({
            ...this.state.filter_data,
            filter_data: data
        }, () => {
            this.getFilterProducts();
        });
    }

    getSortByValue() {
        if (this.state.filter_data?.lowToHigh === true) {
            return "2";
        }

        if (this.state.filter_data?.highToLow === true) {
            return "1";
        }

        return "0";
    }

    renderActiveFilterChips() {
        const {filter_data} = this.state;
        const range = filter_data?.range || [0, 1000];

        return (
            <>
                {(range[0] !== 0 || range[1] !== 1000) &&
                <ActiveFilterChip
                    label={`Price range: $${range[0]} - $${range[1]}`}
                    onRemove={() => {
                        EventEmitter.dispatch('changeRangeResetFilter');
                    }}
                />
                }

                {filter_data?.filter?.is_prime === true &&
                <ActiveFilterChip
                    label="Prime items"
                    onRemove={() => {
                        EventEmitter.dispatch('changePrimeResetFilter');
                    }}
                />
                }

                {filter_data?.filter?.is_bulk === true &&
                <ActiveFilterChip
                    label="Bulk items"
                    onRemove={() => {
                        EventEmitter.dispatch('changeBulkResetFilter');
                    }}
                />
                }

                {filter_data?.filter?.made_locally === true &&
                <ActiveFilterChip
                    label="Local items"
                    onRemove={() => {
                        EventEmitter.dispatch('changeLocalResetFilter');
                    }}
                />
                }

                {filter_data?.filter?.ebt_enabled === true &&
                <ActiveFilterChip
                    label="SNAP EBT Eligible"
                    onRemove={() => {
                        EventEmitter.dispatch('changeEBTResetFilter');
                    }}
                />
                }
            </>
        );
    }


    render() {

        var page_count = this.state.page_meta ? this.state.page_meta.last_page : this.props.page_meta.last_page;
        var progress = this.state.progress ? this.state.progress : this.props.progress;
        var filter_products = this.state.storeItem && this.state.storeItem.length ? this.state.storeItem : this.state.seo_search === 1 ? this.props.search_all_products : [];
        var categorySlug = this.state.filter_data?.categories_slug ? this.state.filter_data?.categories_slug :  this.props.categories_slug ;
        // Social crawlers need an absolute URL; the bundled asset path is relative.
        var ogImageUrl = /^https?:/.test(images.logoImg) ? images.logoImg : BASE_URL() + images.logoImg;

        return (

            <React.Fragment>

                <Helmet>
                    <meta charSet="utf-8"/>
                    <title>Farmer's Fresh Meat - Voted Best Meat Market/Butcher Shop in Houston</title>
                    <meta name="description" content="Farmer's Fresh Meat is proud to be the best butcher shop and meat market in Houston, Texas. Buy wholesale beef, goat meat, chicken, and more - on sale now!"/>
                    <meta name="robots" content="index, follow"/>
                    <meta name="googlebot" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"/>
                    <meta property="og:type" content="article"/>
                    <meta property="og:title" content="Farmer's Fresh Meat - Voted Best Meat Market/Butcher Shop in Houston"/>
                    <meta property="og:description" content="Farmer's Fresh Meat is proud to be the best butcher shop and meat market in Houston, Texas. Buy wholesale beef, goat meat, chicken, and more - on sale now!"/>
                    <meta property="og:url" content={BASE_URL() + this.props.location.pathname}/>
                    <meta property="og:site_name" content="Farmer&#039;s Fresh Meat: Houston Meat Market &amp; Butcher Shop"/>
                    <meta property="article:publisher" content="https://www.facebook.com/farmersfreshmeat"/>
                    <meta property="og:image" content={ogImageUrl}/>
                    <meta property="og:image:width" content="1449"/>
                    <meta property="og:image:height" content="1024"/>
                    <meta name="twitter:card" content="summary_large_image"/>
                    <meta name="twitter:title" content="Farmer's Fresh Meat - Voted Best Meat Market/Butcher Shop in Houston"/>
                    <meta name="twitter:description" content="Farmer's Fresh Meat is proud to be the best butcher shop and meat market in Houston, Texas. Buy wholesale beef, goat meat, chicken, and more - on sale now!"/>
                    <meta name="twitter:image" content={ogImageUrl}/>
                    <meta name="twitter:creator" content="Farmerfreshmeat"/>
                    <meta name="twitter:site" content="Farmerfreshmeat"/>
                    <link rel="canonical" href={BASE_URL() + this.props.location.pathname}/>
                    {this.props.location.pathname === '/' && (
                        <script type="application/ld+json">{JSON.stringify({
                            "@context": "https://schema.org",
                            "@graph": [
                                {
                                    "@type": "Organization",
                                    "@id": "https://farmersfreshmeat.com/#organization",
                                    "name": "Farmer's Fresh Meat",
                                    "url": "https://farmersfreshmeat.com/",
                                    "logo": ogImageUrl,
                                    "sameAs": [
                                        "https://www.facebook.com/farmersfreshmeat",
                                        "https://www.instagram.com/farmersfreshmeat/",
                                        "https://www.youtube.com/user/farmersfreshmeat",
                                        "https://www.pinterest.com/Farmerfreshmeat/",
                                        "https://twitter.com/Farmerfreshmeat"
                                    ]
                                },
                                {
                                    "@type": "WebSite",
                                    "@id": "https://farmersfreshmeat.com/#website",
                                    "url": "https://farmersfreshmeat.com/",
                                    "name": "Farmer's Fresh Meat",
                                    "publisher": {"@id": "https://farmersfreshmeat.com/#organization"},
                                    "inLanguage": "en-US",
                                    "potentialAction": {
                                        "@type": "SearchAction",
                                        "target": "https://farmersfreshmeat.com/search/{search_term_string}",
                                        "query-input": "required name=search_term_string"
                                    }
                                }
                            ]
                        })}</script>
                    )}
                </Helmet>
                <LoadingBar progress={progress} color="blue "/>
                <div className="container-fluid mb-fix">
                    <div className="row">
                        {/* <div className="col-12 div-breadcrumb">
                            {
                                this.state.search_keyword && this.state.search_keyword !== "" && this.state.search_keyword !== null ?
                                    <div className="col-md-12 ">
                                        <div className="breadcrumb-details">
                                            <nav aria-label="breadcrumb">
                                                <ol className="breadcrumb">
                                                    <li className="breadcrumb-item">
                                                        <h3>
                                                            <span
                                                                className="font-weight-normal">Search results for: </span>{" "}
                                                            {"“ " + this.state.search_keyword + " ”"}
                                                        </h3>
                                                    </li>
                                                </ol>
                                            </nav>
                                        </div>
                                    </div>
                                    :
                                    (this.state.filter_data?.categories_name || this.state.filter_data?.categories_name === null && this.props.categories_name ) ?
                                        <div className="col-md-12 ">
                                            <div className="breadcrumb-details">
                                                <nav aria-label="breadcrumb">
                                                    <ol className="breadcrumb mb-0 pb-1">
                                                        <li className="breadcrumb-item"
                                                            onClick={() => this.handleRedirection()}>
                                                            <a href="javascript:void(0)">Farmer's Fresh Meat</a>
                                                        </li>
                                                        <li className="breadcrumb-item"
                                                            onClick={() => this.handleRedirection()}>
                                                            <a href="javascript:void(0)">Shop</a>
                                                        </li>
                                                        <li className="breadcrumb-item active" aria-current="page">
                                                            <a>{CapitalizeFirstLetter(strReplace(this.state?.filter_data?.categories_name ? this.state?.filter_data?.categories_name : this.props.categories_name))}</a>
                                                        </li>
                                                    </ol>
                                                </nav>
                                                <h4 className="mb-4">{CapitalizeFirstLetter(strReplace(this.state?.filter_data?.categories_name ? this.state?.filter_data?.categories_name : this.props.categories_name))}</h4>
                                            </div>
                                        </div>
                                        :
                                        <div className="col-md-12">
                                            <div className="breadcrumb-details">
                                                <nav aria-label="breadcrumb">
                                                    <ol className="breadcrumb mb-0 pb-1">
                                                        <li className="breadcrumb-item">Shop Fresh at</li>
                                                    </ol>
                                                </nav>
                                                <h4 className="mb-4">Houston's Best Meat Market</h4>
                                            </div>
                                        </div>
                            }
                        </div> */}

                        <Sidebar categories_slug={categorySlug} showFilter={this.state.toggle_menu_class}/>

                        <div className="col-12 col-md-10 col-lg-10 col-xl-9 column">
                            {this.props.location.pathname.toString() === "/" && !categorySlug &&
                                <PageIntro title="Houston's Best Meat Market & Butcher Shop">
                                    Fresh beef, goat, lamb, chicken, pork and handmade sausage, cut to order.
                                </PageIntro>
                            }

                            <div className="col-12 info-bar">
                                <div className="row justify-content-between align-items-center">
                                    <div className="col-md-5 d-flex align-items-center">
                                        <div className="col-12 d-flex align-items-center px-0 d-sm-justify-content-center">
                                            {categorySlug ? <h4 className={this.props?.location?.pathname?.includes("wholesale") ? "categoryTitle" : "pb-1 categoryTitle"}>{capitalizeWords(strReplace(categorySlug))}</h4> : (this.props.location.pathname.toString() === "/" ? null : <h4 className="categoryTitle">Houston's Best Meat Market</h4>)}
                                            {/* <small className="mr-2">
                                                <span>Showing</span>{" "}
                                                {this.state.page_meta ? this.state.page_meta.total : this.props.page_meta.total} results
                                            </small> */}
                                            <div className="d-md-flex d-none border-left pl-2 active-filter-list">
                                                {this.renderActiveFilterChips()}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-7 d-flex justify-content-md-end align-items-center mt-2 mt-md-0 d-sm-justify-content-space-between">
                                        <small className="text-muted pr-4 mr-3 border-right border-sm-none f-sm-14">
                                            <span className="d-md-inline-block d-sm-none">Showing</span>{" "}
                                            {this.state.page_meta ? this.state.page_meta.total : this.props.page_meta.total} results
                                        </small>
                                        <div class="d-flex align-items-center">
                                            <btn className="btn-order btn-filter mobileFilterOption" onClick={() => {
                                                    EventEmitter.dispatch('toggleFromFilter');
                                                    this.handleToggleOpen()
                                                }}>
                                                <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor"
                                                    stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"
                                                    className="css-i6dzq1">
                                                    <line x1="4" y1="21" x2="4" y2="14"></line>
                                                    <line x1="4" y1="10" x2="4" y2="3"></line>
                                                    <line x1="12" y1="21" x2="12" y2="12"></line>
                                                    <line x1="12" y1="8" x2="12" y2="3"></line>
                                                    <line x1="20" y1="21" x2="20" y2="16"></line>
                                                    <line x1="20" y1="12" x2="20" y2="3"></line>
                                                    <line x1="1" y1="14" x2="7" y2="14"></line>
                                                    <line x1="9" y1="8" x2="15" y2="8"></line>
                                                    <line x1="17" y1="16" x2="23" y2="16"></line>
                                                </svg>
                                                Filter
                                            </btn>
                                            <span className="mr-2 d-sm-none"> Sort by</span>
                                            <CustomSelect
                                                ariaLabel="Sort products"
                                                className="sortDropdown"
                                                name="sortBy"
                                                value={this.getSortByValue()}
                                                options={[
                                                    {value: "0", label: "Best match"},
                                                    {value: "2", label: "Price low to high"},
                                                    {value: "1", label: "Price high to low"},
                                                ]}
                                                onChange={(e) => this.sortingWithPrice(e)}
                                            />
                                        </div>
                                    </div>

                                    {this.props.location.pathname.toString() === "/" &&
                                        <malignmark className={this.state.toggle_menu_class_show}>
                                            <button className="btn-close" onClick={() => {
                                                this.handleToggleClose()
                                            }}></button>
                                        </malignmark>
                                    }
                                </div>
                            </div>


                            <div className="col-12 filter-div">
                                <div className="col-12 filter-content">
                                    {this.renderActiveFilterChips()}
                                </div>
                            </div>

                            <div className="row display-details" id="products">
                                {!!filter_products.length ? filter_products.map((item) => {
                                            if(item.variables.length > 0) {
                                                return item.item_type === 2 ?
                                                    <FoodCard key={item.id} val={item}/>:
                                                    <CateCard key={item.id} val={item}/>
                                            }
                                        }) :

                                        <div className="py-3 blank-banner">
                                            <img alt="" src={images.order_food}/>
                                            <h2 className="mt-3 mb-1">Item not found</h2>
                                            <p className="mt-1 mb-3">
                                                {
                                                    this.state.search_keyword !== null && this.state.search_keyword !== "" && this.state.filter_data?.categories_name ?
                                                        <>
                                                            <span>We couldn’t find any items named “ {this.state.search_keyword}. ”</span>
                                                            <span>Please try a different keyword or select a product category from our menu.</span>
                                                        </>
                                                        :
                                                        this.state.search_keyword !== null && this.state.search_keyword !== "" ?
                                                            <>
                                                                <span>We couldn’t find any items named “ {this.state.search_keyword} "</span>
                                                                <span>Please try a different keyword or select a product category from our menu.</span>
                                                            </>
                                                            :
                                                            this.state.filter_data?.categories_name ?
                                                                <>
                                                                    <span>We couldn’t find any items. Please try a different product category from our menu.</span>
                                                                </>
                                                            : ""
                                                }
                                            </p>
                                            <button onClick={() => {
                                                this.handleReset()
                                            }} className="mx-auto btn btn-m btn-info w-auto px-3">
                                                View all items
                                            </button>

                                        </div>
                                }
                            </div>
                            {page_count > 1 ?
                                <div className="pagination">
                                    <ReactPaginate
                                        previousLabel={<i className="fas fa-chevron-left"></i>}
                                        nextLabel={<i class="fas fa-chevron-right"></i>}
                                        pageCount={page_count}
                                        onPageChange={this.handlePageChange.bind(this)}
                                        marginPagesDisplayed={0}
                                        pageRangeDisplayed={5}
                                        containerClassName={'paginationBttns'}
                                        previousLinkClassName={'previousBttn'}
                                        nextLinkClassName={'nextBttn'}
                                        disabledClassName={'paginationDisabled'}
                                        activeClassName={'paginationActive'}
                                    />
                                </div>
                                : ""}
                        </div>
                    </div>
                    <btn className="btn-order btn-float" onClick={() => {
                        this.topRedirection()
                    }}>
                        <i className="fas fa-chevron-up"></i>
                    </btn>
                </div>

            {this.props.location.pathname.toString() === "/" && !categorySlug && <CustomerReviews/>}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        cartAddedItems: state.CartReducer.cartItems,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateUserList: (val) => dispatch(updateList({type: 'USER_LIST', data: val})),
    }
};

export default withRouter(withCookies(connect(mapStateToProps, mapDispatchToProps)(SearchItem)))
